import {
  Carnivore,
  DocumentEvents,
  DOMOverlay,
  Sheet,
  SheetEventHandler,
  SheetEvents,
  SheetLayer,
} from '@bluebeam/carnivore';
import CarnivoreLib from 'editor/components/CarnivoreLib';
import { createContext } from 'react';

/* 
NOTE: If you are going to use this context directy, make sure to create a fully populated
      CarnivoreLib instance, and set that in the Provider. NEVER rely on the default that is
      defined here. Best yet, use the <CarnivoreProvider /> component!
*/
const CarnivoreContext = createContext(
  new CarnivoreLib({
    SheetEvents: null as unknown as typeof SheetEvents,
    DocumentEvents: null as unknown as typeof DocumentEvents,
    SheetEventHandler: null as unknown as typeof SheetEventHandler,
    Sheet: null as unknown as typeof Sheet,
    SheetLayer: null as unknown as typeof SheetLayer,
    Carnivore: null as unknown as typeof Carnivore,
    DOMOverlay: null as unknown as typeof DOMOverlay,
  })
);

export default CarnivoreContext;
